export function useLogger(context: string) {
  return {
    info: (...args: any[]) => console.info(`[${context}]`, ...args),
    warn: (...args: any[]) => console.warn(`[${context}]`, ...args),
    error: (...args: any[]) => console.error(`[${context}]`, ...args),
    group: (label: string, callback: () => void) => {
      console.group(`[${context}] ${label}`);
      try {
        callback();
      } finally {
        // A throwing callback must not leave the group open — that would
        // swallow all subsequent log lines into the dead group.
        console.groupEnd();
      }
    }
  }
}
